import React from 'react';
import {Box, Typography} from "@mui/material";

// Avatar rond avec les initiales de l'opérateur
export default function OperateurAvatar({name}) {
    const initials = name ? name.substring(0, 2).toUpperCase() : "??";
    return (
        <Box sx={{
            width: 40, height: 40, borderRadius: "50%",
            backgroundColor: "#EEEDFE", color: "#3C3489",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontWeight: 700, flexShrink: 0,
        }}>
            <Typography variant="body2" fontWeight={700} color="inherit">{initials}</Typography>
        </Box>
    );
}
